// Formatting + small pure helpers shared by every page.

export const money = (n) => '£' + (Math.round((Number(n) || 0) * 100) / 100).toFixed(2);
export const plural = (n, one, many) => `${n} ${n === 1 ? one : (many || one + 's')}`;
export const copies = (n) => plural(n, 'copy', 'copies');
export const cards = (n) => plural(n, 'card');

export function slugify(s) {
  return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
    .replace(/[’'`]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}
// Typographic apostrophes for display only (data keeps whatever the source had).
export const pretty = (s) => String(s == null ? '' : s).replace(/(\w)'(\w)/g, '$1’$2').replace(/(\w)'(\s|$)/g, '$1’$2');

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function toDate(iso) { if (!iso) return null; const d = new Date(iso); return isNaN(d) ? null : d; }
export function dateShort(iso) { const d = toDate(iso); return d ? `${d.getDate()} ${MON[d.getMonth()]}` : String(iso || ''); }
export function dateLong(iso) { const d = toDate(iso); return d ? `${d.getDate()} ${MON[d.getMonth()]} ${d.getFullYear()}` : String(iso || ''); }
// 1074 -> "1,074" (external QA 2026-10-11: player counts had no commas)
export const count = (n) => (n == null || n === '' || isNaN(n) ? String(n ?? '') : Number(n).toLocaleString('en-GB'));
export const ordinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

// Info toasts: 3s + ~1s per 10 words beyond the first 10.
export const toastMs = (t) => 3000 + Math.max(0, Math.ceil((String(t).split(/\s+/).length - 10) / 10)) * 1000;

export function debounce(fn, ms) {
  let t;
  const d = (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
  d.cancel = () => clearTimeout(t);
  return d;
}

// base64url for shareable pasted lists (?list=)
export function encodeList(text) {
  const bytes = new TextEncoder().encode(text);
  let bin = '';
  bytes.forEach((b) => { bin += String.fromCharCode(b); });
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
export function decodeList(s) {
  try {
    const b = atob(String(s).replace(/-/g, '+').replace(/_/g, '/'));
    return new TextDecoder().decode(Uint8Array.from(b, (c) => c.charCodeAt(0)));
  } catch (e) { return ''; }
}

export const TIER_LABEL = { S: 'Tier S', A: 'Tier A', B: 'Tier B', C: 'Tier C' };
